import { Normalization } from '~/utils/normalization'

import type { RealtimeNotificationPayload } from './types'
import type { NotificationCloudEvent } from './interfaces'

// The realtime transport wraps a NotificationInstruction in a CloudEvents 1.0
// envelope; the database inbox persists the same instruction directly. See
// docs: presentation-boundary-audit "Canonical notification and realtime model".
const isNotificationCloudEvent = (
  value: Record<string, unknown>
): value is Record<string, unknown> & NotificationCloudEvent =>
  value['specversion'] === '1.0' && Normalization.isRecord(value['data'])

const unwrapNotificationCloudEvent = (
  event: NotificationCloudEvent
): Partial<RealtimeNotificationPayload> => {
  const { data } = event

  return {
    id: event.id,
    template_code: data.code,
    entity_id: data.entity?.id ?? null,
    severity: data.severity,
    created_at: data.occurred_at,
    ...(data.params !== undefined ? { params: data.params } : {}),
    ...(data.entity?.type !== undefined ? { entity_type: data.entity.type } : {}),
    ...(data.action !== undefined ? { action: data.action } : {})
  }
}

export const notificationCloudEvent = { isNotificationCloudEvent, unwrapNotificationCloudEvent }
